<template>
  <div class="export-and-import">
    <div class="tool-content-btn" @click="showImportModalHandle" v-if="showImportBtn">
      <i class="el-icon-loading" v-show="isRunning || importFetching"></i>
      <img :src="importImg" alt="" v-show="!isRunning && !importFetching" />
      <span>导入案件</span>
    </div>
    <el-dropdown @command="type => exportHandle(type)" :disabled="exporting" v-if="!hideExport">
      <div class="tool-content-btn">
        <i class="el-icon-loading" v-show="exporting"></i>
        <img :src="exportImg" alt="" v-show="!exporting" />
        <span>导出excel</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="typeItem in metadataTypes" :key="typeItem.value" :command="typeItem.value">
          <span>{{ typeItem.label }}</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <caseImportModal
      v-if="importModalShow"
      :show.sync="importModalShow"
      :taskInfo="taskInfo"
      :courseDetail="courseDetail"
      @updTask="cb => refreshImportTaskHandle(cb)"
      @importSuccess="$emit('importSuccess')"
    />
  </div>
</template>

<script>
import exportImg from '@/assets/img/导出primary.png';
import importImg from '@/assets/img/导入primary.png';
import { formatDataSourceHandle } from '@/lib/utils';
import { services } from '@/service';
import { metadataTypes, sysCaseWays } from '@/constant';

import caseImportModal from './caseImportModal';

export default {
  components: { caseImportModal },
  data() {
    return {
      exportImg,
      importImg,
      exporting: false,
      timeoutController: 0,
      taskInfo: null,
      importFetching: true,
      importModalShow: false,
      metadataTypes
    };
  },
  props: {
    courseDetail: {
      type: Object,
      required: true
    },
    researchModel: {
      type: Object,
      default: () => null
    },
    unitVal: {
      type: String,
      default: ''
    },
    dataSource: {
      type: String,
      required: true
    },
    hideImport: {
      type: Boolean,
      default: false
    },
    hideExport: {
      type: Boolean,
      default: false
    },
    uploadShow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isResearch() {
      return !!this.researchModel;
    },
    fields() {
      if (this.isResearch) {
        return this.researchModel.fields;
      } else {
        return this.courseDetail._source.fields;
      }
    },
    isRunning() {
      return this.taskInfo && this.taskInfo._source.status === 'running';
    },
    showImportBtn() {
      return !this.hideImport && sysCaseWays.includes(this.courseDetail._source.instrumentType);
    }
  },
  beforeDestroy() {
    this.clearTimeoutController();
  },
  mounted() {
    this.refreshImportTaskHandle();
  },
  methods: {
    showImportModalHandle() {
      if (this.importFetching) {
        return;
      }
      this.importModalShow = true;
    },
    async exportHandle(downloadType) {
      if (this.exporting) {
        return;
      }
      try {
        this.exporting = true;
        let title = this.courseDetail._source.title;
        if (this.isResearch) {
          title = this.researchModel.title;
        }

        const fields = this.fields.map(item => {
          return { field_name: item.field_name, chinese_name: item.title };
        });
        const params = {
          courseware_id: this.courseDetail._id,
          title,
          query: formatDataSourceHandle(JSON.parse(this.dataSource), { includeCleanerFilter: true }).query,
          fields,
          downloadType,
          isUpload: this.uploadShow,
          parentId: this.unitVal
        };
        const result = await services.courseware.downMetadata2(params);
        const reader = new FileReader();
        reader.readAsDataURL(result);
        reader.onload = e => {
          const a = document.createElement('a');
          a.download = `${this.courseDetail._source.title}.xlsx`;
          a.href = e.target.result;
          a.click();
          this.$message.success('导出成功');
        };
      } catch (err) {
        this.$error(err);
      } finally {
        this.exporting = false;
      }
    },
    clearTimeoutController() {
      if (this.timeoutController) {
        clearTimeout(this.timeoutController);
        this.timeoutController = 0;
      }
    },
    async refreshImportTaskHandle(cb = null) {
      try {
        this.clearTimeoutController();
        const result = await services.courseware.getTaskDetail(this.courseDetail._id);
        this.importFetching = false;
        if (!result || !['running', 'success'].includes(result._source.status)) {
          this.taskInfo = null;
        } else {
          this.taskInfo = result;
          if (this.isRunning) {
            this.timeoutController = setTimeout(() => {
              this.refreshImportTaskHandle();
            }, 2000);
          }
        }
      } catch (err) {
        this.$error(err);
      } finally {
        cb && cb();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.export-and-import {
  .tool-content-btn {
    display: inline-block;
    padding: 5px;
    padding-right: 0;
    font-size: 12px;
    color: #409eff;
    cursor: pointer;
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }

    .el-icon-loading {
      font-size: 14px;
      margin-right: 4px;
    }

    & > img {
      position: relative;
      top: 2px;
      width: 14px;
      margin-right: 4px;
    }
  }
}
</style>
